import { createApp } from 'vue';
import { createPinia } from 'pinia'
import App from "@/js/layouts/App.vue";
import router from "@/js/router";
import vuetify from '@/js/plugins/vuetify';
import { initAnalytics } from '@/js/analytics';
import '@/sass/app.scss';

initAnalytics();

const pinia = createPinia();
const app = createApp(App);

app.use(pinia).use(router).use(vuetify).mount("#app");
